"use strict";

import $ from "jquery";
import video from "../../Shared/Video/index";
import scrollToElm from "../../Shared/helpers/helper.scrollToElm.js";

function init(scope) {
    window.addEventListener("load", () => {
        $(".additional-service .company-place__item").each(function () {
            $(this).css("height", this.clientHeight);
        });
    });

    $(scope).each(function () {
        const faq = $(this);
        const filter = faq.find(".js-faq-filter");
        const items = faq.find(".js-faq-item");
        const toggle = faq.find(".js-faq-toggle");
        const error = faq.find(".js-faq-error");

        let tag = "";
        let tagItems = items;
        const max = 6;

        function updateList() {
            error.slideUp();
            tag = filter.val();
            // update list
            items.slideUp();
            tagItems = items;
            if (tag) {
                tagItems = tagItems.filter("." + tag);
            }
            tagItems.slice(0, max).slideDown();
            // update toggle
            toggle.removeClass("js-toggle--active");
            toggle.find(".btn-cta__text").show();
            toggle.find(".btn-cta__text--opposite").hide();
            if (tagItems.length > max) {
                toggle.parent().show();
            } else {
                toggle.parent().hide();
            }
        }
        updateList();

        // Update filter
        filter.on("change", function () {
            updateList();
        });

        // Show/Hide
        toggle.off().on("click", function (e) {
            e.preventDefault();
            tagItems.slice(max).slideToggle();
            toggle.toggleClass("js-toggle--active");
            toggle.find(".btn-cta__text").toggle();
            toggle.find(".btn-cta__text--opposite").toggle();
        });

        // FAQ content
        faq.on("click", ".js-accordion__toggler", function () {
            const itemBar = $(this);
            const item = itemBar.parent();
            const itemContainer = item.find(".accordion__container");
            const itemContent = item.find(".accordion__content");

            const isItemOpen = itemBar.hasClass(
                "js-accordion__toggler--active",
            );
            const isItemLoaded = itemContainer.hasClass(
                "js-accordion__toggler--compelete",
            );

            const id = itemBar.attr("id");
            const lang = itemBar.attr("data-lang");

            if (!isItemOpen) {
                if (isItemLoaded) {
                    itemBar.addClass("js-accordion__toggler--active");
                    itemContainer.slideDown();
                } else {
                    const loader = faq.find(".module__loading");
                    loader.addClass("active");

                    $.ajax({
                        url: `/api/InnerBlocks/BlockDescription/${id}?lang=${lang}`,
                        type: "GET",
                        success: function (data) {
                            itemContent.html($.parseHTML(data));
                            itemBar.addClass("js-accordion__toggler--active");
                            itemContainer
                                .slideDown()
                                .addClass("js-accordion__toggler--compelete");
                            error.slideUp();
                            scrollToElm(item);
                            video.init();
                        },
                        error: function () {
                            error.slideDown();
                            scrollToElm(error);
                        },
                        complete: function () {
                            loader.removeClass("active");
                        },
                    });
                }
            } else {
                itemBar.removeClass("js-accordion__toggler--active");
                itemContainer.slideUp();
            }
        });
    });

    // Open first item of regular accordion
    const isRegularAccordion = $(".accordion").parents(".js-faq").length === 0;
    if (isRegularAccordion) {
        setTimeout(function () {
            const accordionToggle = $(".accordion")
                .find(".js-accordion__toggler")
                .first();
            accordionToggle.click();
        }, 0);
    }
}

export default {
    init,
};
